import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string | JSX.Element;
}

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs: FAQItem[] = [
    {
      question: 'Do you offer mobile window tinting in Columbia?',
      answer: (
        <>
          Yes! We bring our <a href="/mobile-tinting" className="text-teal-600 hover:text-teal-700 font-medium">mobile tinting service</a> to homes and businesses throughout Columbia, MD. Enjoy professional tinting without leaving your location.
        </>
      ),
    },
    {
      question: 'What tinting services do you offer in Columbia?',
      answer: (
        <>
          We provide <a href="/window-tinting" className="text-teal-600 hover:text-teal-700 font-medium">automotive window tinting</a>, <a href="/commercial-tinting" className="text-teal-600 hover:text-teal-700 font-medium">commercial building tinting</a>, <a href="/headlight-taillight-tinting" className="text-teal-600 hover:text-teal-700 font-medium">headlight and taillight tinting</a>, and <a href="/vehicle-decals" className="text-teal-600 hover:text-teal-700 font-medium">custom vehicle decals</a> throughout Columbia.
        </>
      ),
    },
    {
      question: 'How long does it take to tint windows in Columbia?',
      answer: 'Most vehicle tinting takes 2-4 hours depending on the vehicle size. We offer same-day service for Columbia residents and can work around your schedule with our mobile service.',
    },
    {
      question: 'What is the difference between ceramic and standard tint?',
      answer: 'Ceramic tint offers superior heat rejection (up to 50% more), blocks 99% of UV rays, won\'t fade or turn purple, and doesn\'t interfere with electronics. Standard tint provides good UV protection at a lower price point.',
    },
    {
      question: 'Do you tint commercial buildings in Columbia?',
      answer: (
        <>
          Yes! We specialize in <a href="/commercial-tinting" className="text-teal-600 hover:text-teal-700 font-medium">commercial window tinting</a> for offices, retail stores, and buildings in Columbia. Commercial tinting reduces energy costs and enhances privacy.
        </>
      ),
    },
    {
      question: 'Which Columbia neighborhoods do you serve?',
      answer: 'We serve all Columbia villages including Wilde Lake, Harper\'s Choice, Oakland Mills, Long Reach, Hickory Ridge, River Hill, Kings Contrivance, Town Center, and surrounding Howard County areas.',
    },
    {
      question: 'Is your window tinting guaranteed?',
      answer: 'Yes! All our tinting services come with a lifetime warranty covering peeling, bubbling, fading, and discoloration. We use only premium materials and professional installation techniques.',
    },
    {
      question: 'Can you tint headlights and taillights in Columbia?',
      answer: (
        <>
          Absolutely! Our <a href="/headlight-taillight-tinting" className="text-teal-600 hover:text-teal-700 font-medium">headlight and taillight tinting service</a> gives your vehicle a custom look while maintaining legal visibility standards in Maryland.
        </>
      ),
    },
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 px-4 bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-600">
            Common questions about our window tinting services in Columbia
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border border-gray-200 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-5 text-left bg-white hover:bg-gray-50 transition-colors flex items-center justify-between cursor-pointer"
              >
                <h3 className="text-lg font-semibold text-gray-900 pr-8">
                  {faq.question}
                </h3>
                <i
                  className={`ri-arrow-down-s-line text-2xl text-teal-600 transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 py-4 bg-gray-50 text-gray-700 leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">
            Still have questions? We're here to help!
          </p>
          <a
            href="/contact"
            className="inline-block px-8 py-3 bg-teal-600 text-white font-semibold rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            Contact Us
          </a>
        </div>
      </div>
    </section>
  );
}
